import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { ArchivableEntityInterface } from '../interfaces/archivable-entity.interface';

@Exclude()
export class ArchivableEntityDto implements ArchivableEntityInterface {
  @ApiProperty({
    type: 'boolean',
    title: 'Archived',
    description: 'Set to true if entity has be archived.',
    default: false,
  })
  @Expose()
  archived!: boolean;
}
